import datapoints from '../../datapoints';
import getUndoSendTimeInterval from '../../selectors/getUndoSendTimeInterval';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { logUsage } from 'owa-analytics';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('updateUndoSendOption', (userOptions: UserOptionsType) => {
    const timeInterval = getUndoSendTimeInterval();

    userOptions.MailSendUndoInterval = timeInterval;

    const { name: eventName, customData: customData } = datapoints.TimeIntervalChosen.datapoint;
    logUsage(eventName, customData(timeInterval));
});
